<template>
	<div>
		<FITOutstandingRequirement v-bind="properties" :accountType="accountType"></FITOutstandingRequirement>
</div>
</template>
<script type="text/javascript">
import {FITOutstandingRequirement} from '@/components'
import Cookies from 'js-cookie'

	export default{
		name: 'OutstandingRequirement',
		components:{
			FITOutstandingRequirement
		},
		data(){
			return{
				properties:{
					policyType:'P',
					policyID:this.$store.state.LifePolicy.newLife.policyID,
				}
			}
		},
			computed:{
		accountType(){
      		return this.$store.state.role;
    	  },
		}

	}
</script>


// WEBPACK FOOTER //
// src/Osm/LifePolicy/components/OutstandingRequirement.vue